import { QuestionIcon } from "@chakra-ui/icons";
import { Box, VStack, Image } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import logoimage from "../../assets/logo/logoImg.png";
import { MarkDownConerter } from "../../components/MarkDownConverter/MarkDownConerter";
import { GettingChatHistory } from "../../allApi/api";
import { commonStyle } from "../../styles/commonStyle";
import SkeletonLoader from "../../components/loader/skeletonLoader/SkeletonLoader";
import { WordByWordParagraph } from "../aiWebSearch/aiwebsearch/Wordplay";

function ChatHistory({ sessionId }) {
  const [allChatData, setAllChatData] = useState([]);
  const [loader, setLoader] = useState(true);

  const chatHistoryApiCall = async () => {
    setLoader(true);
    try {
      const response = await GettingChatHistory(sessionId);
      setAllChatData(response);
    } catch (error) {
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    chatHistoryApiCall();
  }, [sessionId]);

  return (
    <VStack
      overflowY="auto" sx={{ ...commonStyle.sx,scrollBehavior: "smooth", }}
      top={0}
      h={"70vh"}
      w={"100%"}
      m={"auto"}
      // sx={{ ...commonStyle.sx }}
    >
      <Box h={"90%"} overflowY="auto" sx={{ ...commonStyle.sx,scrollBehavior: "smooth", }} w="100%" >
        {loader && <SkeletonLoader />}

        {allChatData &&
          allChatData.map((ele, index) => (
            <Box key={index} display="flex" flexDirection="column" mb={4}>
              {ele?.conversation?.user == "user" && (
                <Box display="flex" alignItems="center">
                  <QuestionIcon
                    borderRadius={"50%"}
                    w={6}
                    h={6}
                    color="#48BB78"
                  />
                  <Box ml={2} bg="gray.200" p={2} borderRadius="md">
                    {ele?.conversation?.content}
                  </Box>
                </Box>
              )}

              {ele?.conversation?.ai_role == "Agents" && (
                <Box display="flex" alignItems="center" mt={2}>
                  <Image
                    boxSizing={"border-box"}
                    w={6}
                    src={logoimage}
                    alt="Bot Logo"
                  />
                  <Box ml={2} bg="gray.200" p={2} borderRadius="md">
                    <MarkDownConerter
                      paragraph={ele?.conversation?.ai_content}
                    />
                  </Box>
                </Box>
              )}
            </Box>
          ))}
      </Box>
    </VStack>
  );
}

export default ChatHistory;
